import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs/internal/observable/of';
import { zip } from 'rxjs/internal/observable/zip';
import { catchError, map } from 'rxjs/operators';
import { KazaplanService } from './kazaplan.service';
import { from, Observable } from 'rxjs';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { UserStoreService } from '../../shared/services/state-management/user-store.service';
import {NEVER} from "rxjs/internal/observable/never";
import { KazaPlanService } from '@adeo/ngx-kozikaza-api/kazaplan';

@Injectable()
export class KazaplanResolver  {
    constructor(
        private router: Router,
        private readonly userStoreService: UserStoreService,
        private kazaplanService: KazaplanService,
        private readonly localizeRouterService: LocalizeRouterService,
        private readonly kazaPlanService:KazaPlanService
    ) {
    }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> {
    const planId = route.paramMap.get('planId');
    return (planId) ? zip(
        this.kazaPlanService.getPlanById(planId),
        this.kazaPlanService.getMediasByPlanId(planId,1,1,{filters:[{
          key:'media_available',
          operator:'$eq',
          value:[true] as any
        }]})
        ,
    ).pipe(
      map(([kazaplan, medias]) => { 
        const metas = this.kazaplanService.initMetas(kazaplan, medias, route, true);
        route.data = {...route.data, metasOverride: metas};
        return kazaplan;
      }),
      catchError( (err) => {
        if (err == 'Error: Invalid or expired token') {
          return of(null);
        }

        this.router.navigate(this.localizeRouterService.translateRoute(['/not_found'])as string[],
          {queryParams: {from: err.url}});

        return of(null);
      })
    ) : of(null);
  }
}
